var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1081 14731)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#1c1b18",
    strokeWidth: "2px",
    transform: "translate(-1081 -14731)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "none",
    width: 24,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 1,
    y: 1,
    width: 22,
    height: 16
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1c1b18",
    strokeWidth: "2px",
    d: "M-1079.268-14729.34l10,10,10-10",
    transform: "translate(0.268 0.337)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1c1b18",
    strokeWidth: "2px",
    d: "M-1077.941-14711.14v-11",
    transform: "translate(-10720.127 -3549.655) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1c1b18",
    strokeWidth: "2px",
    d: "M0,0V11",
    transform: "translate(-1058.222 -14714.221) rotate(135)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.bb59120a.svg";
export { ForwardRef as ReactComponent };